import { WebsiteContentMessage } from 'sections/onsite-campaigns/types';
import { DomainRule } from '../../types';
import { hasValidTriggers } from 'sections/onsite-campaigns/pages/CampaignEditor/tabs/CampaignWorkflowTab/components/Workflows/Trigger/utils/hasValidTriggers';

export interface AtLeastOneMessageValidTriggerRequiredRuleDto {
  onsiteMessage?: WebsiteContentMessage;
}

export const AtLeastOneMessageValidTriggerRequiredRuleKey = 'atLeastMessageValidTriggerRequiredRule';

export const AtLeastOneMessageValidTriggerRequiredRule = (
  dto: AtLeastOneMessageValidTriggerRequiredRuleDto,
): DomainRule => {
  // Skip trigger validation for embedded templates as they are triggered by client site load
  if (dto.onsiteMessage?.template?.isEmbedded) {
    return {
      result: 'pass',
      ruleKey: undefined,
    };
  }

  if (!hasValidTriggers(dto.onsiteMessage?.triggers)) {
    return {
      result: 'fail',
      ruleKey: AtLeastOneMessageValidTriggerRequiredRuleKey,
    };
  }
  return {
    result: 'pass',
    ruleKey: undefined,
  };
};
